import { render, staticRenderFns } from "./MineProject.vue?vue&type=template&id=6952b351"
import script from "./MineProject.vue?vue&type=script&lang=js"
export * from "./MineProject.vue?vue&type=script&lang=js"
import style0 from "./MineProject.vue?vue&type=style&index=0&id=6952b351&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports